var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSofa01(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15 42.5V50M45 42.5V50",
    stroke: "#141B34",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M50 22.5C50 17.8269 50 15.4904 48.9953 13.75C48.337 12.6099 47.3902 11.6631 46.25 11.0048C44.5095 10 42.173 10 37.5 10H22.5C17.8269 10 15.4904 10 13.75 11.0048C12.6099 11.6631 11.6631 12.6099 11.0048 13.75C10 15.4904 10 17.8269 10 22.5",
    stroke: "#141B34",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M50 22.5C47.2385 22.5 45 24.7386 45 27.5V32.5C45 34.5683 44.5683 35 42.5 35H17.5C15.4317 35 15 34.5683 15 32.5V27.5C15 24.7386 12.7614 22.5 10 22.5C7.23857 22.5 5 24.7386 5 27.5C5 29.3507 6.0055 30.9665 7.5 31.831V32.5C7.5 37.214 7.5 39.571 8.96447 41.0355C10.4289 42.5 12.786 42.5 17.5 42.5H42.5C47.214 42.5 49.571 42.5 51.0355 41.0355C52.5 39.571 52.5 37.214 52.5 32.5V31.831C53.9945 30.9665 55 29.3507 55 27.5C55 24.7386 52.7615 22.5 50 22.5Z",
    stroke: "#141B34",
    strokeWidth: 1.5,
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSofa01);
export default __webpack_public_path__ + "static/media/sofa-01.efa6dc563eeb5832d0a118f9e0032561.svg";
export { ForwardRef as ReactComponent };